import React from 'react';
import PropTypes from 'prop-types';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import { Container, Title, UsernamesContainer, UserNameText } from './styles';

function GiveawaySimple({ data, styles }) {
  const { text, usernames, winner } = data;

  const fontFamilyTitle = FONT_FAMILY[styles?.text?.font || 'notoSans'];
  const fontFamilyUsername = FONT_FAMILY[styles?.username?.font || 'notoSans'];

  return (
    <>
      <FontFamilyHeader family={fontFamilyTitle} />
      <FontFamilyHeader family={fontFamilyUsername} />
      <Container>
        <Title
          style={{
            color: styles?.text?.color,
            fontFamily: fontFamilyTitle?.family,
            fontSize: styles?.text?.size,
            letterSpacing: styles?.text?.letterSpacing,
            lineHeight: styles?.text?.size
              ? `${styles?.text?.size}px`
              : undefined,
          }}
        >
          {text}
        </Title>
        <UsernamesContainer>
          {!winner &&
            usernames.slice(0, 100).map((username) => (
              <UserNameText
                key={username}
                style={{
                  background: styles.username.background,
                  color: styles.username.color,
                  fontFamily: fontFamilyUsername?.family,
                }}
              >
                {username}
              </UserNameText>
            ))}
          {winner && (
            <UserNameText
              style={{
                background: styles.username.background,
                color: styles.username.color,
                fontFamily: fontFamilyUsername?.family,
              }}
              winner
            >
              {winner}
            </UserNameText>
          )}
        </UsernamesContainer>
      </Container>
    </>
  );
}

GiveawaySimple.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string,
    usernames: PropTypes.arrayOf(PropTypes.string),
    winner: PropTypes.string,
  }),
  styles: PropTypes.shape({
    text: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    username: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
      font: PropTypes.string,
    }),
  }),
};

GiveawaySimple.defaultProps = {
  data: {
    text: 'Sorteo de una PS5',
    usernames: [
      'Anonymous',
      'MikelGartzia',
      'Kidi',
      'WorldPadelTour',
      'mejoratupadel',
      'coscu',
    ],
    winner: 'MikelGartzia',
  },
  styles: {
    text: {
      color: '#E0E0E0',
      font: 'notoSans',
      letterSpacing: 0,
      size: 55,
    },
    username: {
      background: '#ffa726',
      color: '#333',
      font: 'notoSans',
    },
  },
};

export default GiveawaySimple;
